<script>
import { videoMethods, workoutComputed, workoutMethods } from '@/src/state/helpers';

export default {
  components: {},
  props: {},
  data() {
    return {
      disabledMobileMenu: true // Temporarily disable mobile menu
    };
  },
  computed: {
    ...workoutComputed,
  },
  mounted() {},
  methods: {
    ...videoMethods,
    ...workoutMethods,
    endWorkout() {
      this.setVideoAction('pause');
      this.$bvModal.show('end-workout-modal');
    },
    showTips() {
      this.setVideoAction('pause');
      this.$bvModal.show('tips-modal');
    },
  },
};
</script>

<template>
  <div class="exercise-video-subheader">
    <span @click="endWorkout">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-close'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g filter="url(#filter0_b)"><circle cx="16" cy="16" r="16" fill="#9F9F9F" fill-opacity=".4"/></g><path d="M20 12l-8 8m0-8l8 8" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><defs><filter id="filter0_b" x="-4" y="-4" width="40" height="40" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImage" stdDeviation="2"/><feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur"/><feBlend in="SourceGraphic" in2="effect1_backgroundBlur" result="shape"/></filter></defs></svg>
    </span>
    <span @click="showTips" v-if="currentExercise.tips.length">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-info-circle'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g filter="url(#filter0_b)"><circle cx="16" cy="16" r="16" fill="#9F9F9F" fill-opacity=".4"/></g><path d="M14.54 10.844c0 .758.6 1.367 1.366 1.367.766 0 1.367-.61 1.367-1.367-.007-.774-.601-1.375-1.367-1.375-.765 0-1.367.601-1.367 1.375zM12.483 21.07c.008.61.43 1 1.086 1h4.86c.656 0 1.078-.39 1.086-1 .007-.625-.414-1.015-1.086-1.015h-1.172v-5.242c0-.633-.414-1.024-1.04-1.024H13.79c-.672 0-1.094.39-1.094 1.016.008.61.43 1 1.094 1h1.336v4.25H13.57c-.672 0-1.093.39-1.086 1.015z" fill="#fff"/><defs><filter id="filter0_b" x="-4" y="-4" width="40" height="40" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImage" stdDeviation="2"/><feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur"/><feBlend in="SourceGraphic" in2="effect1_backgroundBlur" result="shape"/></filter></defs></svg>
    </span>

    <div class="subheader-actions-mobile">
      <div class="pill-tips" @click="showTips" v-if="currentExercise.tips.length">
        <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-info'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M2.54 1.844c0 .758.6 1.367 1.366 1.367.766 0 1.367-.61 1.367-1.367C5.266 1.07 4.672.469 3.906.469c-.765 0-1.367.601-1.367 1.375zM.483 12.07c.008.61.43 1 1.086 1h4.86c.656 0 1.078-.39 1.086-1 .007-.625-.414-1.015-1.086-1.015H5.258V5.813c0-.633-.414-1.024-1.04-1.024H1.79c-.672 0-1.094.39-1.094 1.016.008.61.43 1 1.094 1h1.336v4.25H1.57c-.672 0-1.093.39-1.086 1.015z" fill="#fff"/></svg>
        Tips
      </div>
      <span v-if="!disabledMobileMenu">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-menu'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g filter="url(#filter0_b)"><circle cx="16" cy="16" r="16" fill="#9F9F9F" fill-opacity=".4"/></g><path d="M9.477 12.71a1.21 1.21 0 000-2.42 1.212 1.212 0 000 2.42zm3.843-.366h10.555a.837.837 0 00.852-.844.842.842 0 00-.852-.844H13.32a.837.837 0 00-.851.844c0 .477.375.844.851.844zm-3.843 5.234a1.21 1.21 0 000-2.422 1.212 1.212 0 000 2.422zm3.843-.367h10.555a.837.837 0 00.852-.844.842.842 0 00-.852-.844H13.32a.837.837 0 00-.851.844c0 .477.375.844.851.844zm-3.843 5.234a1.21 1.21 0 000-2.422 1.212 1.212 0 000 2.422zm3.843-.367h10.555a.837.837 0 00.852-.844.842.842 0 00-.852-.843H13.32a.837.837 0 00-.851.843c0 .477.375.844.851.844z" fill="#fff"/><defs><filter id="filter0_b" x="-4" y="-4" width="40" height="40" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feGaussianBlur in="BackgroundImage" stdDeviation="2"/><feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur"/><feBlend in="SourceGraphic" in2="effect1_backgroundBlur" result="shape"/></filter></defs></svg>
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.exercise-video-subheader {
  display: flex;
  justify-content: space-between;
  margin: 4rem auto 0;
  width: 93%;

  @include media('xxl', null) {
    margin: 2rem auto;
  }

  .icon-info-circle {
    display: none;

    @include media('xxl', null) {
      display: block;
    }
  }

  .icon-close,
  .icon-info-circle,
  .icon-menu {
    background-color: rgba(28, 28, 28, 0.3);
    border-radius: 50%;

    &:hover {
      cursor: pointer;
    }
  }

  .subheader-actions-mobile {
    display: flex;
    justify-content: space-between;

    @include media('xxl', null) {
      display: none;
    }

    .pill-tips {
      @include calc-font-size(1.1);

      align-items: center;
      backdrop-filter: blur(4px);
      background: rgba(159, 159, 159, 0.4);
      border-radius: 3.9rem;
      color: white;
      display: flex;
      font-weight: 600;
      letter-spacing: 1px;
      line-height: 2.8rem;
      margin-right: 1rem;
      padding: 0 1.2rem;
      text-transform: uppercase;

      .icon-info {
        margin-right: 1rem;
      }
    }
  }
}
</style>
